import Handsontable from 'handsontable/base';
import { TABLE_DEFAULT_COL_WIDTH, TABLE_DEFAULT_ROW_HEIGHT } from '../../../../../../common/table/tableConstants';

/**
 * Returns the default rendered column width for a table at the current grid size.
 */
export const getDefaultTableColWidth = (gridSize: number): number => TABLE_DEFAULT_COL_WIDTH * gridSize;

/**
 * Returns the default rendered row height, preserving the existing top/bottom border offsets.
 */
export const getDefaultTableRowHeight = ({
    index,
    gridSize,
    hotTableInstance,
}: {
    index: number;
    gridSize: number;
    hotTableInstance: Handsontable | null;
}): number | undefined => {
    if (!hotTableInstance) return;

    const nRows = hotTableInstance.countRows();
    const offset = index === nRows - 1 ? 1 : 0;
    return TABLE_DEFAULT_ROW_HEIGHT * gridSize - offset;
};
